import Splide from '@splidejs/splide';
export const init = () => {
    if (document.querySelector('.carousel_type-3')) {
        const carousel3 = document.querySelectorAll('.carousel_type-3');
        carousel3.forEach((item) => {
            const paginationCount = item.dataset.paginations;
            const autoplayButton = item.querySelector('.splide__toggle');
            const splideCarousel3 = new Splide(item, {
                type: 'fade',
                arrows: false,
                pagination: true,
                autoplay: 'pause',
                interval: 2000,
                drag: false,
                lazyLoad: 'nearby',
                classes: {
                    pagination: 'splide__pagination g-pagination__type-2', 
                }, 
            });
            let paginations = [];
            splideCarousel3.on('pagination:mounted', (data) => {
                paginations = dividePaginationItems(paginationCount, data.items)
                paginations.forEach((arr, index) => {
                    if (index != 0)
                        arr.forEach((item) => {
                            item.button.classList.add('hidden');
                        });
                });
            });
            splideCarousel3.mount();

            if (splideCarousel3.length > 1) {
                const { Controller, Autoplay } = splideCarousel3.Components;
                const arrowLeft = item.querySelector('.button--prev');
                const arrowRight = item.querySelector('.button--next');

                item.addEventListener('mouseenter', () => {
                    arrowLeft.classList.remove('hidden');
                    arrowRight.classList.remove('hidden');
                });
                item.addEventListener('mouseleave', () => {
                    arrowLeft.classList.add('hidden');
                    arrowRight.classList.add('hidden');
                });

                splideCarousel3.on('move', (newIndex) => {
                    if (Controller.getIndex() === Controller.getEnd()) {
                        Autoplay.pause();
                    } 
                    switch (newIndex) { 
                        case 0: 
                            arrowLeft.classList.add('u-js-hide'); 
                            arrowRight.classList.remove('u-js-hide');
                            break;
                        case Controller.getEnd():
                            arrowRight.classList.add('u-js-hide');  
                            arrowLeft.classList.remove('u-js-hide');
                            break;
                        default:
                            arrowLeft.classList.remove('u-js-hide');
                            arrowRight.classList.remove('u-js-hide');  
                    } 
                });
                splideCarousel3.on('pagination:updated', () => {
                    paginations.forEach((arr) => {
                        const containsPage = arr.some(i => i.page === Controller.getIndex());
                        if (containsPage) 
                            arr.forEach((item) => item.button.classList.remove('hidden'))
                        else 
                            arr.forEach((item) => item.button.classList.add('hidden'))
                    });
                });
             
                arrowLeft.addEventListener('click', () => Controller.go('<'));
                arrowRight.addEventListener('click', () => Controller.go('>')); 
                autoplayButton.addEventListener('click', () => Controller.getIndex() === Controller.getEnd() ? Controller.go(0): false);  
            }
            else {
                autoplayButton.classList.add('hidden');
            }    
        });
    }
    function dividePaginationItems(count, array) {
        let parts = [];
        for (let i=0; i < array.length; i += Number(count)) {
            let tempArray;
            tempArray = array.slice(i, i + Number(count));
            parts.push(tempArray);
        }
        return parts;
    }
}